<div class="rbt-dashboard-area rbt-section-overlayping-top rbt-section-gapBottom" style="margin: 50px 0;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <!-- Start Dashboard Top  -->
                <div class="rbt-dashboard-content-wrapper">
                    <div class="tutor-bg-photo bg_image bg_image--22 height-350">
                    </div>
                    <div class="rbt-tutor-information">
                        <div class="rbt-tutor-information-left">
                            <div class="thumbnail rbt-avatars size-lg">
                                <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.teacher.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                            </div>
                            <div class="tutor-content">
                                <h5 class="title">{{teacher.name}} {{teacher.surname}}</h5>
                                <ul class="rbt-meta rbt-meta-white mt--5">
                                    <li>{{teacher.courses.length}} {{'course' | translate}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Dashboard Top  -->
            </div>
            <div class="col-lg-12 mt--30">
                <div class="profile-content rbt-shadow-box">
                    <h4 class="rbt-title-style-3">{{'aboutTeacher' | translate}}</h4>
                    <div class="row g-5">
                        <div class="col-lg-8">
                            <p class="mt--10 mb--20">{{teacher.bio}}</p>
                            <ul class="rbt-information-list mt--15">
                                <li>
                                    <a href="tel:+{{teacher.mobile}}"><i class="feather-phone" style="margin-left: 10px;"></i> {{teacher.mobile}}</a>
                                </li>
                                <li>
                                    <a href="mailto:{{teacher.emailAddress}}"><i class="feather-mail" style="margin-left: 10px;"></i>{{teacher.emailAddress}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Start Card Area -->
        <div class="rbt-profile-course-area mt--60">
            <div class="row">
                <div class="col-lg-12">
                    <div class="sction-title">
                        <h2 class="rbt-title-style-3">{{'Courses' | translate}}</h2>
                    </div>
                </div>
            </div>
            <div class="row g-5 mt--5">
                <!-- Start Single Card  -->
                <div class="col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let course of teacher.courses | paginate: { itemsPerPage: 9, currentPage: p }">
                    <div class="rbt-card variation-01 rbt-hover" *ngIf="course.hide === false">
                        <div class="rbt-card-img" (click)="openDetail(course.id)">
                            <a>
                                <span *ngIf="course.status === 'Completed'" class="Completed"><span class="dot_blue"></span> {{'Completed' | translate}} </span>
                                <span *ngIf="course.status === 'Finished'" class="Finished"><span class="dot_red"></span> {{'Finished' | translate}}</span>
                                <span *ngIf="course.status === 'Available'" class="availabe"><span class="dot_green"></span> {{'Available' | translate}}</span>
                                <img style="max-height: 220px;min-height: 220px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                            </a>
                        </div>
                        <div class="rbt-card-body">
                            <div class="rbt-card-top">
                                <!-- <div class="rbt-review">
                                    <div class="rating">
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                        <i class="fas fa-star"></i>
                                    </div>
                                </div>
                                <div class="rbt-bookmark-btn">
                                    <a class="rbt-round-btn" title="Bookmark" href="#"><i
                                            class="feather-bookmark"></i></a>
                                </div> -->
                            </div>

                            <h4 class="rbt-card-title" (click)="openDetail(course.id)"><a>{{course.courseNameAr}}</a>
                            </h4>

                            <ul class="rbt-meta">
                                <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                <li>{{course.studentsNo}} {{'Students' | translate}}</li>

                                <li style="float: inline-end;">{{'from' | translate}} {{course.startDate | date: 'dd/MM'}} {{'To' | translate}}{{course.endDate | date: 'dd/MM'}}</li>
                            </ul>

                            <p class="rbt-card-text">{{course.summary}}</p>
                            <!-- <div class="rbt-author-meta mb--10">
                                <div class="rbt-avater">
                                    <a href="#">
                                        <img src="assets/images/client/avatar.png" alt="Sophia Jaymes">
                                    </a>
                                </div>
                            </div> -->
                            <div class="rbt-card-bottom">
                                <div class="rbt-price" *ngIf="course.price === 0">
                                    <span class="current-price">{{'Free' | translate}}</span>
                                </div>
                                <div class="rbt-price" *ngIf="course.price > course.offerPrice">
                                    <span class="current-price">{{course.offerPrice}} {{'SAR' | translate}}</span>
                                    <span class="off-price">{{course.price}} {{'SAR' | translate}}</span>
                                </div>
                                <div class="rbt-price" *ngIf="course.offerPrice > course.price">
                                    <span class="current-price">{{course.price}} {{'SAR' | translate}}</span>
                                </div>
                                <a class="rbt-btn-link" (click)="openDetail(course.id)">{{'details' | translate}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Card  -->
            </div>

            <div class="row">
                <div class="col-lg-12 mt--60">
                    <pagination-controls 
                    class="rbt-pagination" 
                    (pageChange)="p = $event"
                    previousLabel=""
                    nextLabel=""
                    ></pagination-controls>
                </div>
            </div>
        </div>
        <!-- End Card Area -->
    </div>
</div>
